import { render, staticRenderFns } from "./OtnTemplate.vue?vue&type=template&id=6c552ac5&scoped=true&"
import script from "./OtnTemplate.vue?vue&type=script&lang=js&"
export * from "./OtnTemplate.vue?vue&type=script&lang=js&"
import style0 from "./OtnTemplate.vue?vue&type=style&index=0&id=6c552ac5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c552ac5",
  null
  
)

export default component.exports